import _ from 'lodash';
import React from 'react';
import { generateUUID, getUniqueKey } from '../_utils';
import { IconID } from '../icon';
import { Menu } from '../menu';
export const ActionMenu = ({ menuItemGroups, id: Id, show = false, className = '', disableKeyboardNavigation = false, menuTheme = undefined, ...restProps }) => {
    const renderChildren = (menuItem) => {
        const { cascadingItems, customContent } = menuItem;
        if (cascadingItems) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            return renderCascadingItems(menuItem);
        }
        return customContent;
    };
    const checkHasLeftIcon = (menuItemGroup) => {
        return (menuItemGroup &&
            menuItemGroup.some((group) => group.items.some((item) => item.icon || item.isSelected)));
    };
    const checkHasRightIcon = (menuItemGroup) => {
        return (menuItemGroup &&
            menuItemGroup.some((group) => group.items.some((item) => item.cascadingItems)));
    };
    const renderMenuItem = (menuItem, hasChild = false, hasLeftIcon = false, hasRightIcon = false) => {
        const { id, label, icon, customIcon, itemDisabled, onClick, isSelected, itemTooltip, itemDisabledTooltip, trackId, ...rest } = menuItem;
        let defaultIcon = isSelected ? IconID.CHECKMARK : icon;
        if (customIcon) {
            defaultIcon = customIcon.id;
        }
        if (!defaultIcon && hasLeftIcon) {
            defaultIcon = IconID.EMPTY;
        }
        return (React.createElement(Menu.Item, { key: generateUUID(), label: label, id: id, iconName: defaultIcon, customIcon: customIcon, disabled: itemDisabled, onSelect: onClick, hasRightIconInGroup: hasRightIcon, itemTooltip: itemTooltip, itemDisabledTooltip: itemDisabledTooltip, trackId: trackId, ..._.omit(rest, 'cascadingItems', 'customContent') }, hasChild && renderChildren(menuItem)));
    };
    const renderGroup = (groupMenuItem, showSeparator = false, hasLeftIcon = false, hasRightIcon = false) => (React.createElement(Menu.Group, { key: generateUUID(), showSeparator: showSeparator },
        React.createElement(React.Fragment, null, groupMenuItem.items.map((groupItem) => {
            const { cascadingItems, customContent, } = groupItem;
            if (cascadingItems || customContent) {
                return renderMenuItem(groupItem, true, hasLeftIcon, hasRightIcon);
            }
            return renderMenuItem(groupItem, false, hasLeftIcon, hasRightIcon);
        }))));
    const renderCascadingItems = (menuItem) => {
        const { id, label, cascadingItems } = menuItem;
        const hasLeftIcon = checkHasLeftIcon(cascadingItems);
        const hasRightIcon = checkHasRightIcon(cascadingItems);
        return (!_.isEmpty(cascadingItems) && (React.createElement(Menu, { id: `cascading_menu${id}${label}`, show: show }, cascadingItems.map((cascadingItem, index) => {
            if ('items' in cascadingItem) {
                return renderGroup(cascadingItem, !(cascadingItems.length - 1 === index), hasLeftIcon, hasRightIcon);
            }
            return renderMenuItem(cascadingItem, false, hasLeftIcon, hasRightIcon);
        }))));
    };
    const hasLeftIcon = checkHasLeftIcon(menuItemGroups);
    const hasRighttIcon = checkHasRightIcon(menuItemGroups);
    return (React.createElement(React.Fragment, null, show && !_.isEmpty(menuItemGroups) && (React.createElement(Menu, { id: `actionmenu_${Id || getUniqueKey('default')}`, show: true, className: className, disableKeyboardNavigation: disableKeyboardNavigation, menuTheme: menuTheme, ...restProps }, menuItemGroups.map((menuItem, index) => renderGroup(menuItem, !(menuItemGroups.length - 1 === index), hasLeftIcon, hasRighttIcon))))));
};
//# sourceMappingURL=action-menu.js.map